import { getDocument } from '@/helpers/globals'

type MediumSource = {
    medium: string
    source: string
}
export function useMediumSource(): MediumSource {
    // Store query params from non-UTM url
    const document = getDocument()

    let medium: string
    let source: string
    let referrer = document?.referrer || ''
    const baidu_regex = new RegExp('https://www.baidu.com/.*')

    if (baidu_regex.test(referrer)) {
        referrer = 'baidu'
    }

    switch (referrer) {
        case '':
            source = 'direct'
            medium = 'none'
            break

        case 'https://www.google.com/':
            source = 'google'
            medium = 'organic'
            break

        case 'https://www.bing.com/':
            source = 'bing'
            medium = 'organic'
            break

        case 'https://search.yahoo.com/':
            source = 'yahoo'
            medium = 'organic'
            break

        case 'https://yandex.com/':
            source = 'yandex'
            medium = 'organic'
            break

        case 'https://duckduckgo.com/':
            source = 'duckduckgo'
            medium = 'organic'
            break

        case 'baidu':
            source = 'baidu'
            medium = 'organic'
            break

        default:
            medium = 'referral'
            source = referrer
            break
    }

    return {
        medium,
        source,
    }
}
